export const configMaps = [
  { code: 'PRODUCT_CLOUD_JUST_SUPPLY', hintText: '价格设置', linkUrl: '/product/supplyProdList', activeTabKey: 'CLOUD_SPOT' }, // 现货云供应导入
  { code: 'PRODUCT_CLOUD_FUTURES_JUST_SUPPLY', hintText: '期货设置', linkUrl: '/product/supplyProdList', activeTabKey: 'CLOUD_FUTURES' }, // 期货云供应导入
  { code: 'PRODUCT_STOCK_JUST_SUPPLY', hintText: '库存设置', linkUrl: '/warehouse/goodsIn' }
]
